import type { PropsWithChildren } from "react";
import React from "react";
import type { CrmConnectorContextProps } from "./CrmConectorContext";
import { CrmConnectorContext } from "./CrmConectorContext";

export const CrmConnectorContextProvider = ({ children, ...val }: PropsWithChildren<CrmConnectorContextProps>) => (
  <CrmConnectorContext value={val}>{children}</CrmConnectorContext>
);
